import { Route as ItemsReorderRoute } from "@/routes/(inventory)/branch/_layout/reports/items-reorder-report/index";
import { useQuery } from "@tanstack/react-query";
import { getItemsReorder } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useItemsReorderData = () => {
  const searchParams = ItemsReorderRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["items-reorder", searchParams],
    queryFn: async () => {
      const response = await getItemsReorder(searchParams.page || 1, searchParams.pageSize || 10);
      return {
        items: response.itemsToReorder,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};